import PropTypes from 'prop-types';
import React, {Component} from 'react';
import * as Colors from 'material-ui/styles/colors';
import Toggle from 'material-ui/Toggle';
import {Tabs, Tab} from 'material-ui/Tabs';
import FontIcon from 'material-ui/FontIcon';
import _ from 'lodash';
import IconButton from 'material-ui/IconButton';
import * as Consts from './Consts';
import BaseElementDialog from '../BaseElementDialog/BaseElementDialog';
import GallerOrganizer from './GalleryOrganizer';
import MultiImageUploaderHelper from '../../../../shared/helpers/MultiImageUploaderHelper';
import {cLencodeURIcomponent} from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
import {connect} from 'react-redux';
import ImageManager from './ImageManagerConnect';
import GlobalStore from './GlobalStore';
import {WebAddressesLoader} from 'MyAccount/AssetManager/ImageManager/components/WebAddressesLoader';
import {checkFileName} from 'MyAccount/AssetManager/ImageManager/helpers';
import {getIsAdmin} from 'crazyEditor/redux/modules/user/userSelectors';
import {store} from 'crazyEditor/redux/store';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

const INITIAL_STATE = {
  showGalleryOrganizer: true,
  webUrlsValid: false,
  images: null,
  selectedImages: null,
  addingToGallery: false,
  showWebAddressesLoader: false,
  imageManagerState: {
    currentFolder: '',
    photos: [],
    uploadImages: [],
  },
};

@connectWithRouter(
  state => ({
    templateTag: state.user.templateTagSetName,
    bulkReviseEnabled: state.user.bulkReviseEnabled,
    query: state.routing.location.query,
    listingData: state.listingData,
  }),
  {}
)
export default class GalleryDialog extends Component {
  static contextTypes = {
    imageUtils: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.onAddUpdate = this.onAddUpdate.bind(this);
    this.getElementProps = this.getElementProps.bind(this);

    this.state = {...INITIAL_STATE, showThumbnails: _.get(props, 'selectedElement.data.showThumbnails')};
  }

  componentWillMount() {
    const {open} = this.props;
    if (open) {
      this.onOpen(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {open} = nextProps;
    if (!this.props.open && open) {
      this.onOpen(nextProps);
    } else if (this.props.open && !open) {
      this.onClose();
    }
  }

  onOpen = props => {
    const {bulkReviseEnabled, listingData, query} = this.props;
    const isListingPage = !_.isEmpty(listingData) || query.draft;
    const initialImages =
      bulkReviseEnabled && !isListingPage ? this.getDefaultImageList() : _.get(props, 'selectedElement.data.list', []);
    const state = {...INITIAL_STATE};
    if (initialImages.length === 0) {
      state.showGalleryOrganizer = false;
    }
    this.setState(state);
    this._multiImageUploaderHelper = new MultiImageUploaderHelper(this.imagesUpdateHandler);
    this.expectedImages = initialImages.length;
    this._multiImageUploaderHelper.addExistingImages(initialImages);
  };

  onClose = () => {
    if (this._lastUploadXhr) {
      this._lastUploadXhr.abort();
      this._lastUploadXhr = null;
    }
  };

  onAddUpdate() {
    const {onAddUpdate} = this.props;
    const {showGalleryOrganizer, showWebAddressesLoader} = this.state;
    if (showGalleryOrganizer) {
      onAddUpdate(this.getElementProps());
    } else if (showWebAddressesLoader) {
      this.uploadImageFromUrl();
    } else {
      if (!this.state.addingToGallery) {
        this.setState({addingToGallery: true});
        this.showGalleryOrganizer();
      }
    }
  }

  onWebUrlsValidChange = webUrlsValid => {
    this.setState({webUrlsValid});
  };

  onCancel = () => {
    const {showGalleryOrganizer, showWebAddressesLoader} = this.state;
    const {onCancel} = this.props;
    if (showGalleryOrganizer) {
      return onCancel();
    }
    return showWebAddressesLoader ? this.closeWebAddressesLoader() : onCancel();
  };

  getDefaultImageList() {
    const {
      publish,
      selectedElement: {data = {}},
    } = this.props;
    const {maxImages, startIndex, imageTag, firstImageTag} = this.props.selectedElement.data.templateTagData || {};
    let {list} = this.props.selectedElement.data;
    if (
      maxImages &&
      _.isEmpty(this.props.selectedElement.data.listingData) &&
      !getIsAdmin(store.getState() /* THIS USAGE OF STORE SHOULD NOT SET AN EXAMPLE */)
    ) {
      // Placeholder Gallery should render normal for admin user so the renders will have the images.
      if (publish) {
        list = _.range(startIndex, maxImages + startIndex).map(index => imageTag.replace('###', `${index}`));
        if (firstImageTag) {
          list.splice(0, 0, firstImageTag);
          list.pop();
        }
      } else {
        if (data.bulkReviseEnabled) {
          list = _.range(1, 1 + maxImages).map(
            index => `https://misc.crazylister.com/bulkPlaceholders/BulkPlaceholder${index}.svg`
          );
        } else {
          list = _.range(1, 1 + maxImages).map(
            index => `https://misc.crazylister.com/placeHolders/imagePlaceHolder${index}.svg`
          );
        }
      }
    }
    return list;
  }

  getElementProps() {
    return {
      data: {
        list: this.getSrcs(),
        showThumbnails: this.state.showThumbnails,
      },
    };
  }

  getSrcs = () => {
    const images = _.sortBy(this._multiImageUploaderHelper.images, 'order');
    return _.map(images, image => {
      return cLencodeURIcomponent(image.src);
    });
  };

  getWebUrls = webUrls => {
    this.setState({webUrls});
  };

  getBackButton() {
    const {showWebAddressesLoader} = this.state;
    return (
      <IconButton
        onClick={showWebAddressesLoader ? this.closeWebAddressesLoader : this.showGalleryOrganizer}
        iconStyle={{color: Colors.white}}
      >
        <FontIcon className="material-icons">arrow_back</FontIcon>
      </IconButton>
    );
  }

  getImageManager() {
    const {showWebAddressesLoader} = this.state;
    return showWebAddressesLoader ? (
      <WebAddressesLoader
        ref="webAddressesLoader"
        onValidChange={this.onWebUrlsValidChange}
        getUrls={this.getWebUrls}
      />
    ) : (
      <ImageManager
        changeImages={selectedImages => this.setState({selectedImages})}
        getImageManagerState={imageManagerState => this.setState({imageManagerState})}
        resourceType="Images"
        style={{height: '100%', width: '100%'}}
        uploadImagesDirectToEditor={images => this.uploadImagesDirectToEditor(images)}
        openIntegratedUploadFromUrlDialog={() => this.setState({showWebAddressesLoader: true})}
      />
    );
  }

  uploadImageFromUrl = () => {
    const {webUrls} = this.state;
    const urlsWithName = _.map(webUrls, url => ({...url, name: _.last(_.split(url.src, '/'))}));
    const {photos, uploadFiles, currentFolder} = this.state.imageManagerState;
    this.closeWebAddressesLoader();
    const checkNameArr = [];
    const path = currentFolder ? `/${_.replace(currentFolder, /\\/gi, '/')}/` : '/';
    _.map(urlsWithName, (url, index) => {
      const newUrl = url.src;
      let name = url.name;
      if (!_.endsWith(name, '.jpg') || !_.endsWith(name, '.png') || !_.endsWith(name, '.jpeg')) {
        name = name
          .split('/')
          .pop()
          .split('#')[0]
          .split('?')[0];
      }
      const fileNameSplited = _.split(name, '.');
      let i = 0;
      while (
        name !== checkFileName(checkNameArr, name) ||
        name !== checkFileName(photos, name) ||
        name !== checkFileName(uploadFiles, name)
      ) {
        if (_.size(fileNameSplited) === 1) {
          name = `${fileNameSplited[0]}(${i})`;
        } else {
          const fileExt = _.last(fileNameSplited);
          name = `${_.join(_.dropRight(fileNameSplited), '.')}(${i}).${fileExt}`;
        }
        i += 1;
      }
      checkNameArr.push({name});
      this.uploadImageDirectToEditorFromUrl(newUrl);
      this.context.imageUtils.doUploadFilesFromUrl({newUrl, path, name}, result => {
        if (_.get(result, 'success')) {
          this.closeWebAddressesLoader();
        } else {
          console.log('Error while editing image', _.get(result, 'error'));
        }
      });
    });
  };

  closeWebAddressesLoader = () => {
    this.setState({showWebAddressesLoader: false});
  };

  uploadImagesDirectToEditor(files) {
    _.map(files, file => this._multiImageUploaderHelper._uploadImage(file));
    this.setState({showGalleryOrganizer: true});
  }

  uploadImageDirectToEditorFromUrl(src) {
    this._multiImageUploaderHelper.addExistingImage(src);
    this.setState({showGalleryOrganizer: true});
  }

  closeGalleryOrganizer = () => {
    this.setState({showGalleryOrganizer: false, addingToGallery: false});
  };

  showGalleryOrganizer = () => {
    const {onAddUpdate} = this.props;
    const {showGalleryOrganizer, selectedImages} = this.state;
    this._multiImageUploaderHelper.addExistingImages(_.map(selectedImages, image => image.url));
    this.setState({showGalleryOrganizer: true});
  };

  imagesUpdateHandler = _.throttle(() => {
    const stateUpdate = {};
    const {images} = this.state;
    const newImages = this._multiImageUploaderHelper.images;
    if (this.expectedImages) {
      if (this.expectedImages > _.size(newImages)) {
        return;
      }
      this.expectedImages = null;
    }
    // if (_.size(images) > 0) {
    //   stateUpdate.showGalleryOrganizer = true;
    // }
    stateUpdate.images = newImages;
    this.setState(stateUpdate);
  }, 250);

  isInputValid = () => {
    const {onCancel, open, newElement} = this.props;
    const {
      selectedTab,
      showGalleryOrganizer,
      images,
      selectedImages,
      ckfinderPlaceholderRef,
      webUrlsValid,
      showWebAddressesLoader,
    } = this.state;
    if (showGalleryOrganizer) {
      return _.size(images) > 0 && this._multiImageUploaderHelper.allValid();
    }
    if (showWebAddressesLoader) {
      return this.state.webUrlsValid;
    }
    return _.size(selectedImages) > 0;
  };

  primaryButtonLabel = () => {
    return this.state.addingToGallery ? 'Adding...' : 'add to gallery';
  };

  _multiImageUploaderHelper;

  showToggleLabel() {
    const {bulkReviseEnabled, query, listingData} = this.props;
    let show = false;
    if (bulkReviseEnabled) {
      if (_.isEmpty(listingData) && !query.draft) {
        show = true;
      }
    }
    return show;
  }

  render() {
    const {onCancel, open, newElement, templateTag, bulkReviseEnabled, query, listingData} = this.props;
    const {
      selectedTab,
      images,
      showGalleryOrganizer,
      ckfinderPlaceholderRef,
      webUrlsValid,
      showThumbnails,
      showWebAddressesLoader,
    } = this.state;
    return (
      <BaseElementDialog
        open={open}
        title={
          showGalleryOrganizer ? (
            'Organize Gallery'
          ) : (
            <span style={{display: 'flex', alignItems: 'center'}}>
              {this.getBackButton()}
              {showWebAddressesLoader ? 'Upload images from URL' : 'Add Images'}
            </span>
          )
        }
        onCancel={this.onCancel}
        inputValid={this.isInputValid()}
        onAddUpdate={this.onAddUpdate}
        primaryButtonLabel={showGalleryOrganizer ? null : this.primaryButtonLabel()}
        secondaryButtonLabel={showGalleryOrganizer ? 'cancel' : 'back'}
        newElement={newElement}
        contentStyle={{
          width: Consts.DIALOG_WIDTH,
          maxWidth: Consts.DIALOG_WIDTH,
          height: Consts.DIALOG_HEIGHT,
          maxHeight: Consts.DIALOG_HEIGHT,
          userSelect: 'none',
        }}
        innerDivStyle={{
          height: Consts.CONTENT_HEIGHT,
          maxHeight: Consts.CONTENT_HEIGHT,
        }}
        buttonsSectionStyle={{backgroundColor: Colors.grey50}}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            overflowX: 'hidden',
            overflowY: showGalleryOrganizer || showWebAddressesLoader ? 'auto' : 'hidden',
            display: showGalleryOrganizer ? 'flex' : 'block',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          {showGalleryOrganizer && !(templateTag && !bulkReviseEnabled) && (
            <div style={{marginLeft: 40, marginTop: 30, marginBottom: -5}}>
              <Toggle
                labelPosition="right"
                label={'Show thumbnails under the gallery'}
                labelStyle={{textIndent: 10}}
                toggled={showThumbnails}
                onToggle={() => this.setState({showThumbnails: !showThumbnails})}
              />
              {this.showToggleLabel() && (
                <div style={{marginTop: 10}}>
                  The placeholders below will be auto populated with listings images when the template is applied to a
                  listing.
                </div>
              )}
            </div>
          )}
          {showGalleryOrganizer ? (
            <GallerOrganizer
              onAddImagesClicked={this.closeGalleryOrganizer}
              onRemoveImagesClicked={_.get(this, '_multiImageUploaderHelper.removeHandler')}
              images={images}
              disabled={!!this.expectedImages}
              bulkReviseEnabled={bulkReviseEnabled}
              query={query}
              listingData={listingData}
            />
          ) : (
            this.getImageManager()
          )}
        </div>
      </BaseElementDialog>
    );
  }
}
